<template>
  <div class="el-autocomplete-item">
    <div
      v-if="showIcon"
      class="el-autocomplete-item__icon-wrap"
    >
      <i
        v-if="item.accreditedTest"
        class="el-autocomplete-item__icon el-icon-document-checked"
      />
      <i
        v-else
        class="el-autocomplete-item__icon el-icon-document"
      />
    </div>

    <div class="el-autocomplete-item__text-wrap">
      <h4>
        {{ item.code }}
        <span
          v-if="showNumber && item.value"
          class="el-autocomplete-item__number"
        >
          {{ $t('global.analysisNumber', { number: item.value }) }}
        </span>
      </h4>
      <p>
        {{ item.description }}, <em>{{ item.method }}</em>
      </p>
      <p v-if="item.instrument">{{ item.instrument }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AutocompleteAnalysis',
    props: {
      item: Object,
      showIcon: { type: Boolean, default: true },
      showNumber: { type: Boolean, default: false },
    },
  };
</script>

<style lang="scss" scoped>
  // .el-autocomplete {
  //   width: 100%;
  // }
  .el-autocomplete-item {
    display: flex;
    align-items: center;
    border-bottom: 1px dashed $--border-color-light;
    padding: 0.5em 0;
    &__icon-wrap {
      padding-right: 1rem;
    }
    &__icon {
      font-size: 1.5rem;
    }
    &__text-wrap {
      line-height: 2;
      h4 {
        font-weight: bold;
      }
      p {
        white-space: initial;
      }
    }
    &__number {
      margin-left: 0.5rem;
      font-weight: normal;
      font-size: 0.85em;
      color: $--color-text-regular;
    }
  }
</style>
